import { Link } from 'react-router-dom';
import logo from '../../assets/images/OrcheXtra_logo.svg';
import { useAuthContext } from '../../context/AuthContext';
import { routesMap } from '../../routes/routesMap';
import { useEffect, useMemo, useState, useRef } from 'react';

export default function Header() {
  const auth = useAuthContext();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Log dei token per debug
  useEffect(() => {
    if (auth.isAuthenticated) {
 //  console.log('User info:', auth.user?.profile);
 //  console.log('Access token:', auth.user?.access_token);
 //  console.log('ID token:', auth.user?.id_token);
    }
  }, [auth.isAuthenticated, auth.user]);

  // Calcola le iniziali
  const initials = useMemo(() => {
    const given = auth.user?.profile?.given_name ?? '';
    const family = auth.user?.profile?.family_name ?? '';
    return `${given.charAt(0).toUpperCase()}${family.charAt(0).toUpperCase()}`;
  }, [auth.user?.profile?.given_name, auth.user?.profile?.family_name]);

  // Logout Keycloak
  const handleLogout = async () => {
    console.log('[Logout] click registrato. id_token presente?', !!auth.user?.id_token);
    try {
      await auth.signoutRedirect({ id_token_hint: auth.user?.id_token });
    } catch (err) {
      console.error('[Logout] signoutRedirect ha fallito:', err);
      // Fallback: rimuove l'utente lato client e ricarica
      try {
        await auth.removeUser();
      } catch (e) {
        console.error('[Logout] anche removeUser ha fallito:', e);
      }
      window.location.href = window.location.origin;
    }
  };

  // Chiude il dropdown se clicchi fuori
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        event.target instanceof Node && // ✅ garantisce che target sia Node
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="bg-white border-b border-borderDivider shadow-sm px-10 py-4 flex justify-between items-center sticky top-0 z-40">
      <Link to={routesMap.HOME_PAGE}>
        <img src={logo} alt="Logo" className="h-8" />
      </Link>

      <div className="relative" ref={dropdownRef}>
        <div
          className="flex items-center justify-center w-10 h-10 rounded-full bg-textPrimary text-white font-medium cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
          title="User menu"
        >
          {initials}
        </div>

        {isOpen && (
          <div className="absolute right-0 mt-2 w-32 bg-white border border-borderDivider rounded shadow-lg z-50">
            <div className="px-4 py-2 text-sm text-gray-700">
              {auth.user?.profile?.given_name} {auth.user?.profile?.family_name}
            </div>
            <div className="border-t border-borderDivider"></div>
            <button
              type="button"
              className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm text-red-600 font-medium"
              onPointerDown={() => console.log('[Logout] pointerdown')}
              onMouseDown={() => console.log('[Logout] mousedown')}
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
